const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"] as const;
const STORAGE_KEY = "td_utm";

export type UtmParams = Partial<Record<(typeof UTM_KEYS)[number], string>>;

/** Capture UTM params from the current URL and persist in sessionStorage (first-touch wins). */
export function captureUtmParams(): void {
  // Don't overwrite — keep the first landing's params
  if (sessionStorage.getItem(STORAGE_KEY)) return;

  const url = new URL(window.location.href);
  const params: UtmParams = {};
  let found = false;

  for (const key of UTM_KEYS) {
    const val = url.searchParams.get(key);
    if (val) {
      params[key] = val;
      found = true;
    }
  }

  if (found) {
    // Also store landing page and referrer
    (params as any).landing_page = window.location.pathname;
    (params as any).referrer = document.referrer || null;
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(params));
  }
}

/** Get the stored UTM params (or empty object). */
export function getUtmParams(): UtmParams & { landing_page?: string; referrer?: string | null } {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}

/** Check if the session has UTM attribution. */
export function hasUtmAttribution(): boolean {
  return !!sessionStorage.getItem(STORAGE_KEY);
}
